exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-automation[data-v-3b8ece25] {\n  background: #98afc7 !important;\n}\n", ""]);

// exports
